// extracted by mini-css-extract-plugin
export default {"wrap":"statistics_wrap__KkFm-","ul":"statistics_ul__X5GYg"};